<template>
  <div class="logo-social-media-content" id="identidade-visual-logo-versao-redes-sociais-e-favicon" data-search-anchor>
    <div class="title-social-media-wrapper">
      <h1 class="logo-social-media-title-span">{{ logoSocialMediaVersionTitleSpan }}</h1>
      <h1 class="logo-social-media-title">{{ logoSocialMediaVersionTitle }}</h1>
    </div>
    <div class="description-social-media-wrapper">
      <div>
        <p class="logo-social-media-description">{{ logoSocialMediaVersionDescription }}</p>
        <div class="icon-social-media-wrapper">
          <IconCheck />
          <p class="logo-social-media-description1">{{ logoSocialMediaVersionDescription1 }}</p>
        </div>
      </div>      
    </div>

    <div class="logo-social-media-img-bottom">
      <div
        class="logo-social-media-card-item-bottom"
        :style="{ backgroundImage: `url(${logoSocialMediaVersionImageBottomSrc})` }"
      ></div>
    </div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import VisualIdentityPageMixin from '@/mixins/visual-identity-page-mixin'
import { VisualIdentityPageStore } from '@/store/visual-identity-page/visual-identity-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class LogoSocialMediaVersionSection extends Mixins(VisualIdentityPageMixin) {
  visualIdentityPageStore: PageStoreContract = getModule(VisualIdentityPageStore, this.$store)

  get logoSocialMediaVersionTitleSpan(): string {
    return this.getElementTitle(12, 0)
  }

  get logoSocialMediaVersionTitle(): string {
    return this.getElementText(12, 0)
  }

  get logoSocialMediaVersionDescription(): string {
    return this.getElementText(12, 1)
  }

  get logoSocialMediaVersionDescription1(): string {
    return this.getElementText(12, 2)
  }

  get logoSocialMediaVersionImageBottomSrc(): string {
    return this.getElementMedia(12, 3)
  }

  async getVisualIdentityPage(): Promise<void> {
    await this.visualIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.visualIdentityPageStore.isLoading) {
      await this.getVisualIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.logo-social-media-content {
  width: 100%;
  display: grid;
  max-width: 1032px;
}

.title-social-media-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 2rem;
}

.logo-social-media-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  margin-right: 5px;
  color: #b3b3b3;
}

.logo-social-media-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;

  color: #000000;
}

.icon-social-media-wrapper {
  display: flex;
  align-items: center;  
}

.description-social-media-wrapper { 
  position: relative;  

  display: grid;
  grid-template-columns: 1fr 1fr;  
}

.logo-social-media-description,
.logo-social-media-description1 {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  
  width: 430px;
  margin: 0;
}

.logo-social-media-description1{
  padding-left: 7px;
  width: 378px;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.logo-social-media-card-item {
  position: relative;
  bottom: 3rem;
  left: 3rem;

  width: 361px;
  height: 291px;

  background-repeat: no-repeat;
  background-position: center;
}

.logo-social-media-img-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-social-media-card-item-bottom {
  position: relative;    
  width: 100%;
  max-width: 1032px;
  height: 705px;    
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
